import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter, Linkedin, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer style={{
    backgroundColor: '#1F2937'
  }} className="text-gray-300" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-92">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-93">
          {/* Brand */}
          <div data-id="element-94">
            <div className="flex items-center gap-2 mb-4" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/sUJaz5otqstKeYZYCx3DsW/IMG_5963.jpg" alt="Talk in Rubbish logo" className="h-9 w-auto rounded-md" data-id="element-96" />
              <span className="font-bold text-white text-lg" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-97">
                Talk in Rubbish
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-4" style={{
            color: '#9CA3AF'
          }} data-id="element-98">
              Licensed waste carrier serving Chingford, North London, East
              London & Enfield. Eco-friendly, fully insured, and always on time.
            </p>
            <p className="text-sm font-semibold italic" style={{
            color: '#1B8F4B'
          }} data-id="element-99">
              "Green, Clean, and Always on Time."
            </p>
            <div className="flex gap-3 mt-5" data-id="element-100">
              {[Facebook, Instagram, Twitter, Linkedin].map((Icon, i) => <a key={i} href="#" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors hover:bg-[#1B8F4B]" style={{
              backgroundColor: '#374151'
            }} data-id="element-101">
                  <Icon className="w-4 h-4 text-white" data-id="element-102" />
                </a>)}
            </div>
          </div>

          {/* Services */}
          <div data-id="element-103">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-104">
              Our Services
            </h4>
            <ul className="space-y-2" data-id="element-105">
              {[['House Clearance', '/services/house-clearance'], ['Office Removals', '/services/office-removals'], ['Commercial Waste', '/services/commercial-waste'], ['Garden Waste', '/services/garden-waste'], ['Overseas Removals', '/services/overseas-removals'], ['Estate Agent Clearance', '/services/estate-agent'], ['Cost Calculator', '/calculator']].map(([label, href]) => <li key={href} data-id="element-106">
                  <Link to={href} className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-107">
                    {label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-108">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-109">
              Service Areas
            </h4>
            <ul className="space-y-2" data-id="element-110">
              {['Chingford', 'Enfield', 'North London', 'East London', 'Walthamstow', 'Tottenham', 'Edmonton', 'Hackney', 'All London Boroughs'].map(area => <li key={area} className="text-sm" style={{
              color: '#9CA3AF'
            }} data-id="element-111">
                  {area}
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-112">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-113">
              Contact Us
            </h4>
            <ul className="space-y-3" data-id="element-114">
              <li className="flex items-start gap-2" data-id="element-115">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-116" />
                <a href="tel:+447405641227" className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-117">
                  07405 641227
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-118">
                <MessageCircle className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-119" />
                <a href="https://wa.me/447405641227" className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-120">
                  WhatsApp Us
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-121">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-122" />
                <a href="mailto:info@talkinrubbish.com" className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-123">
                  info@talkinrubbish.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-124">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-125" />
                <span className="text-sm" style={{
                color: '#9CA3AF'
              }} data-id="element-126">
                  Chingford, London, UK
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-127">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-128" />
                <div className="text-sm" style={{
                color: '#9CA3AF'
              }} data-id="element-129">
                  <p data-id="element-130">Mon–Sat: 7am – 8pm</p>
                  <p data-id="element-131">Sun: 8am – 6pm</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t" style={{
      borderColor: '#374151'
    }} data-id="element-132">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-133">
          <p className="text-xs" style={{
          color: '#6B7280'
        }} data-id="element-134">
            © 2024 Talk in Rubbish Ltd. Licensed Waste Carrier.
          </p>
          <div className="flex gap-4" data-id="element-135">
            {['Privacy Policy', 'Terms & Conditions', 'Cookie Policy'].map(item => <a key={item} href="#" className="text-xs hover:text-[#1B8F4B] transition-colors" style={{
            color: '#6B7280'
          }} data-id="element-136">
                  {item}
                </a>)}
          </div>
        </div>
      </div>
    </footer>;
}